import {
    FORMAT_SD_CARD_OPEN_MODAL,
    FORMAT_SD_CARD_CLOSE_MODAL,
    FORMAT_SD_CARD_REQUEST,
    FORMAT_SD_CARD_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {

        case FORMAT_SD_CARD_OPEN_MODAL:
            return { ...state, openModal: true }

        case FORMAT_SD_CARD_CLOSE_MODAL:
            return { ...state, openModal: false }

        case FORMAT_SD_CARD_REQUEST:
            return { ...state, loading: true }

        case FORMAT_SD_CARD_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "FORMAT_SD_CARD"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
                
        default:
            return state;
    }
};